import { useState, useEffect } from "react";
import { Flex, View } from "@adobe/react-spectrum";
import { useSelector } from "react-redux";
import ChatList from "../../ChatPage/ChatList/ChatList";
import ChatHeader from "../ChatHeader/ChatHeader";
import ChatTranscript from "../ChatTranscript/ChatTranscript";
import ChannelHistoryFilter from "../../common/ChannelHistoryFilter/ChannelHistoryFilter";
import ActiveCallContainer from "../../CallTab/CallDialer/ActiveCallContainer";
import { RootState } from "../../../store/storeConfig";
import { IndividualChat } from "../../../types/chat.type";
import ChatInfo from "../ChatInfo/ChatInfo";

const ChatHistory = () => {
  const history = useSelector((state: RootState) => state.history);
  const common = useSelector((state: RootState) => state.common);

  const [chatDetail, setChatDetail] = useState<IndividualChat | null>(null);
  const [showChatDetail, setShowChatDetail] = useState<boolean>(true);
  const [uplodingFiles, setUploadingFiles] = useState({});
  const [filterAction, setFilterAction] = useState<"all" | "missed">("all");
  const [chatList, setChatList] = useState<IndividualChat[]>(
    history.chat || []
  );

  useEffect(() => {
    if (history.chat?.length > 0) {
      setChatDetail(history.chat[0]);
      setChatList(history.chat);
    } else {
      setChatDetail(null);
      setChatList([]);
    }
  }, [history.chat]);

  const handleAll = () => {
    setFilterAction("all");
    const allChats = history.chat || [];
    setChatList(allChats);
    setChatDetail(allChats.length > 0 ? allChats[0] : null);
  };

  const handleMissed = () => {
    setFilterAction("missed");
    const missedChats = (history.chat || []).filter(
      (chatItem: IndividualChat) => chatItem?.self?.missed
    );
    setChatList(missedChats);
    setChatDetail(missedChats.length > 0 ? missedChats[0] : null);
  };

  const handleActiveChatId = (id: string) => {
    const activeChat = (history.chat || []).find(
      (chatItem: IndividualChat) => chatItem.id === id
    );
    setChatDetail(activeChat || null);
  };

  const handleShowChatDetail = () => {
    setShowChatDetail(!showChatDetail);
  };

  return (
    <>
      {history?.chat?.length > 0 ? (
        <>
          <ChannelHistoryFilter
            activeFilter={filterAction}
            onAll={handleAll}
            onMissed={handleMissed}
          />
          {chatList.length > 0 ? (
            <Flex
              direction={"row"}
              UNSAFE_className="chat-history-container"
              width={"100%"}
            >
              {/* Chat List */}
              <View
                backgroundColor="static-white"
                width={"20%"}
                borderEndWidth={"thick"}
                borderEndColor={"gray-200"}
              >
                <ChatList
                  chat={chatList}
                  activeChatId={chatDetail?.id}
                  handleActiveChatId={handleActiveChatId}
                />
              </View>

              {/* Main chat area */}
              <Flex direction={"column"} width={"68.4%"}>
                <View backgroundColor="static-white">
                  <ChatHeader
                    chatDetail={chatDetail}
                    showChatDetail={showChatDetail}
                    handleShowChatDetail={handleShowChatDetail}
                  />
                </View>

                <View
                  backgroundColor="static-white"
                  UNSAFE_className="chat-transcript-container"
                  height={common.tab === "History" ? "100%" : "80%"}
                >
                  <ChatTranscript
                    chatType={"chatHistory"}
                    typingStatus={false}
                    activeChatId={chatDetail?.id || ""}
                    uplodingFiles={uplodingFiles}
                    setUploadingFiles={setUploadingFiles}
                  />
                </View>
                {/* Optional: You can add a ChatFooter here if needed */}
              </Flex>

              {/* Chat info panel */}
              <View
                width={"31.6%"}
                UNSAFE_className="chatinfo-container"
                backgroundColor="static-white"
              >
                <ChatInfo
                  isLiveChat={false}
                  isHistory={true}
                  activeChatId={chatDetail?.id as string}
                />
              </View>
            </Flex>
          ) : (
            <Flex
              alignItems="center"
              justifyContent="center"
              width="90%"
              height="90%"
            >
              <ActiveCallContainer
                type="chat"
                title={
                  filterAction === "missed"
                    ? "No Missed Chat history"
                    : "No Chat history"
                }
                description={
                  filterAction === "missed"
                    ? "Start a new chat or wait for the chat"
                    : "Start a new chat or wait for the chat"
                }
              />
            </Flex>
          )}
        </>
      ) : (
        <Flex
          alignItems={"center"}
          justifyContent={"center"}
          height={"100%"}
          width={"100%"}
        >
          <ActiveCallContainer
            type="chat"
            title="No chat in history"
            description="There is no chat history at this time"
          />
        </Flex>
      )}
    </>
  );
};

export default ChatHistory;
